<template>
    <select
            :id="id"
            :name="id"
            :disabled="disabled"
            v-model="selected"
            @change="onChange($event.target.value)"
            @blur="setTouched(true)">
        <option v-for="option in options" :value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>

<script>
	export default {
		name: "ParentalLockSelectBox",
		data() {
			return {
				touched: false,
			}
		},
		props: ['id', 'value', 'options', 'disabled'],
		computed: {
			selected: {
				get() {
					return this.value
				},
				set() {
					// declaring setter, but assigning value with onChange method
				}
			},
			isInvalid() {
				return this.touched && this.required && !this.value
			},
		},
		methods: {
			onChange(value) {
				if (value === '') {
					value = null
				}
				this.$emit('input', value)
				this.setTouched(true)
			},
			setTouched(value) {
				this.touched = value
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/ParentalLockSelectBox.vue